'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _components = require('../../components');

var _urls = require('../../utils/urls');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _dates = require('../../utils/dates');

var _caterwaulComponents = require('@liveauctioneers/caterwaul-components');

var _reactIntl = require('react-intl');

var _noop = require('../../utils/noop');

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _live = require('../../utils/live');

var _countDown = require('../../utils/countDown');

var _CatalogCard = require('./CatalogCard.scss');

var _CatalogCard2 = _interopRequireDefault(_CatalogCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CatalogCard = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(CatalogCard, _Component);

    function CatalogCard() {
        (0, _classCallCheck3.default)(this, CatalogCard);
        return (0, _possibleConstructorReturn3.default)(this, (CatalogCard.__proto__ || (0, _getPrototypeOf2.default)(CatalogCard)).apply(this, arguments));
    }

    (0, _createClass3.default)(CatalogCard, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'featured', 'cardViewModel']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                cardViewModel = _props.cardViewModel,
                className = _props.className,
                featured = _props.featured,
                trackClick = _props.trackClick;
            var catalog = cardViewModel.catalog,
                coverLots = cardViewModel.coverLots,
                seller = cardViewModel.seller;

            var _ref = catalog || {},
                catalogId = _ref.catalogId,
                catalogStatus = _ref.catalogStatus,
                isCatalogOnly = _ref.isCatalogOnly,
                saleStartTs = _ref.saleStartTs,
                sellerId = _ref.sellerId,
                title = _ref.title;

            var _ref2 = seller || {},
                _ref2$countryCode = _ref2.countryCode,
                countryCode = _ref2$countryCode === undefined ? 'us' : _ref2$countryCode,
                sellerName = _ref2.name;

            var classes = [].concat((0, _toConsumableArray3.default)(className.split(' ')), [_CatalogCard2.default['catalog-card']]).join(' ').trim();

            var coverLotsClasses = featured ? _CatalogCard2.default.featured + ' ' + _CatalogCard2.default['cover-lots'] : _CatalogCard2.default['cover-lots'];
            var startDate = (0, _dates.catalogCardDate)(saleStartTs);
            var catalogUrl = (0, _urls.getCatalogUrl)(catalogId, title);
            var showDate = !isCatalogOnly && (0, _countDown.showCountDownBasedOnMinimumDate)(saleStartTs);

            var leftStyles = featured ? _CatalogCard2.default.left + ' ' + _CatalogCard2.default['featured-left'] : _CatalogCard2.default.left;

            var showLiveButton = (0, _live.shouldShowLive)(catalogStatus, isCatalogOnly, saleStartTs);

            return (0, _jsx3.default)('div', {
                className: classes,
                onClick: trackClick
            }, void 0, (0, _jsx3.default)(_components.CoverLots, {
                catalogId: catalogId,
                catalogUrl: catalogUrl,
                className: coverLotsClasses,
                coverLots: coverLots,
                featured: featured,
                sellerId: sellerId
            }), (0, _jsx3.default)('div', {
                className: _CatalogCard2.default['card-body']
            }, void 0, (0, _jsx3.default)('div', {
                className: leftStyles
            }, void 0, (0, _jsx3.default)('div', {
                className: _CatalogCard2.default.title
            }, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: catalogUrl,
                primary: true
            }, void 0, title)), (0, _jsx3.default)('div', {
                className: _CatalogCard2.default.seller
            }, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getSellerUrl)(sellerId, sellerName),
                primary: true
            }, void 0, sellerName)), (0, _jsx3.default)('div', {
                className: _CatalogCard2.default.date
            }, void 0, startDate)), (0, _jsx3.default)('div', {
                className: _CatalogCard2.default.right
            }, void 0, featured ? (0, _jsx3.default)(_components.ButtonLink, {
                url: catalogUrl,
                className: _CatalogCard2.default.explore
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'explore'
            })) : (0, _jsx3.default)(_caterwaulComponents.Flag, {
                className: _CatalogCard2.default.flag,
                countryCode: countryCode
            }), showLiveButton ? (0, _jsx3.default)(_components.BidConsoleOpener, {
                catalogId: catalogId,
                sellerId: sellerId
            }, void 0, (0, _jsx3.default)('span', {
                className: _CatalogCard2.default.live
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'live_auction'
            }))) : (0, _jsx3.default)('span', {}, void 0, catalogStatus !== 'done' ? (0, _jsx3.default)(_components.CatalogDate, {
                className: _CatalogCard2.default.countdown,
                date: saleStartTs,
                showDate: showDate
            }) : (0, _jsx3.default)('span', {
                className: _CatalogCard2.default.ended
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auction_ended'
            }))))));
        }
    }]);
    return CatalogCard;
}(_react.Component), _class.defaultProps = {
    cardViewModel: {},
    className: '',
    featured: false,
    trackClick: _noop2.default
}, _temp);
exports.default = CatalogCard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CatalogCard/CatalogCard.js
// module id = Kk/C
// module chunks = 57